// Helper to get current term name for term-based students
export function getTermName(student, academicYears, termsList, fullProfile) {
  const ayId = resolveId(student.academicYearId);
  const termId = fullProfile?.term || student.term;
  if (!ayId || !termId) return '-';
  // Try to find in provided termsList first
  if (termsList && termsList.length > 0) {
    const t = termsList.find(t => resolveId(t._id) === termId);
    return t ? t.termLabel : '-';
  }
  // Fallback: try to find in academicYears if terms are nested
  const year = academicYears.find(y => resolveId(y._id) === ayId);
  const t = year?.terms?.find(t => resolveId(t._id) === termId);
  return t ? t.termLabel : '-';
}

// Robust ID resolver for MongoDB $oid vs string
function resolveId(idObj) {
  if (!idObj) return null;
  if (typeof idObj === 'string') return idObj;
  return idObj.$oid || idObj.id || idObj._id || null;
}
